(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  let activePurchase;
  const updateSticky = (purchase, offer) => {
    activePurchase = purchase;
    document.querySelectorAll('[data-tb-sticky]').forEach((bar) => {
      bar.querySelector('[data-tb-sticky-label]').textContent = offer.dataset.label || 'NIGHT 01';
      bar.querySelector('[data-tb-sticky-price]').textContent = `${offer.dataset.total || ''}${offer.dataset.subscription === 'true' ? ' / month' : ' total'}`;
      const submit = purchase.querySelector('button[type="submit"]');
      bar.querySelector('[data-tb-sticky-button]').textContent = submit && !submit.disabled ? 'ADD TO CART →' : 'VIEW OFFER ↑';
    });
  };
  const initPurchase = (purchase) => {
    if (purchase.dataset.initialized === 'true') return;
    purchase.dataset.initialized = 'true';

    const offers = Array.from(purchase.querySelectorAll('[data-offer]'));
    const form = purchase.querySelector('[data-tb-product-form]');
    const quantityInput = purchase.querySelector('[data-tb-quantity]');
    const error = purchase.querySelector('[data-tb-error]');
    const submit = form?.querySelector('button[type="submit"]');
    const checkoutReady = purchase.dataset.checkoutReady === 'true' && purchase.dataset.available === 'true';

    let pending = false;
    const choose = (offer) => {
      if (!offer || pending) return;
      offers.forEach((item) => {
        const selected = item === offer;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (quantityInput) quantityInput.value = offer.dataset.quantity || '1';
      const subscriptionUnavailable = offer.dataset.subscription === 'true' && !purchase.dataset.subscriptionPlan;
      if (submit) {
        submit.disabled = !checkoutReady || subscriptionUnavailable;
        submit.textContent = !checkoutReady ? 'AVAILABLE SOON' : subscriptionUnavailable ? 'SUBSCRIPTION COMING SOON' : `ADD TO CART — ${offer.dataset.total || ''}`;
      }
      if (error) {
        error.hidden = true;
        error.textContent = '';
        if (subscriptionUnavailable) {
          error.hidden = false;
          error.textContent = 'Monthly subscription is not available yet. Please choose a one-time offer.';
        }
      }
      updateSticky(purchase, offer);
    };

    offers.forEach((offer) => offer.addEventListener('click', () => choose(offer)));
    choose(purchase.querySelector('.is-selected') || offers[0]);

    if (!form) return;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const selected = purchase.querySelector('[data-offer].is-selected');
      if (!checkoutReady || pending) return;

      if (selected && selected.dataset.subscription === 'true') {
        if (!purchase.dataset.subscriptionPlan) return;
      }

      pending = true;
      submit.disabled = true;
      offers.forEach((offer) => { offer.disabled = true; });
      const originalLabel = submit.textContent;
      submit.textContent = 'ADDING…';
      updateSticky(purchase, selected);

      try {
        const data = new FormData(form);
        if (selected?.dataset.subscription === 'true') {
          data.set('selling_plan', purchase.dataset.subscriptionPlan);
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'Unable to add this offer to cart.');

        const discountCode = selected?.dataset.code?.trim();
        if (discountCode) {
          const root = window.Shopify?.routes?.root || '/';
          window.location.assign(`${root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(`${root}cart`)}`);
        } else {
          window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        }
      } catch (message) {
        if (error) {
          error.textContent = message.message || 'Unable to add this offer to cart.';
          error.hidden = false;
        }
        pending = false;
        offers.forEach((offer) => { offer.disabled = false; });
        submit.disabled = false;
        submit.textContent = originalLabel;
        updateSticky(purchase, selected);
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-tb-purchase]').forEach(initPurchase);
    document.querySelectorAll('[data-tb-sticky-button]').forEach((button) => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const purchase = activePurchase?.isConnected ? activePurchase : document.querySelector('[data-tb-purchase]');
        const submit = purchase?.querySelector('button[type="submit"]');
        if (submit && !submit.disabled) purchase.querySelector('form').requestSubmit();
        else purchase?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      });
    });
    document.querySelectorAll('[data-tb-hero]').forEach((hero) => {
      hero.querySelectorAll('[data-tb-gallery-button]').forEach((button) => {
        if (button.dataset.initialized) return;
        button.dataset.initialized = 'true';
        button.addEventListener('click', () => {
          const images = hero.querySelectorAll('.tb-hero__desktop-image img, [data-tb-gallery-main] img');
          if (!images.length || !button.dataset.imageUrl) return;
          images.forEach((img) => {
            img.removeAttribute('srcset');
            img.src = button.dataset.imageUrl;
            img.alt = button.dataset.imageAlt || '';
            img.style.objectFit = 'contain';
          });
          hero.querySelectorAll('[data-tb-gallery-button]').forEach((item) => {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', String(item === button));
          });
        });
      });
    });
    document.querySelectorAll('.tb-mobile-menu a').forEach((link) => {
      if (link.dataset.initialized) return;
      link.dataset.initialized = 'true';
      link.addEventListener('click', () => link.closest('details').removeAttribute('open'));
    });
  };
  ready(initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
